import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=2604ee3e&scoped=true"
import script from "./Enquiries.vue?vue&type=script&lang=js"
export * from "./Enquiries.vue?vue&type=script&lang=js"
import style0 from "./Enquiries.vue?vue&type=style&index=0&id=2604ee3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604ee3e",
  null
  
)

export default component.exports